import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'rk-share-content-wrapper',
  template: ` <ng-content></ng-content> `,
  styleUrls: ['./share-content-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareContentWrapperComponent {
  @HostBinding('class.closer')
  @Input()
  close = false;
}
